















import { Component, Prop, Emit, Vue } from "vue-property-decorator";

@Component
export default class InputCheckboxComponent extends Vue {
  @Prop()
  inputId!: string;

  @Prop({
    default: false
  })
  isChecked!: boolean;

  @Emit()
  change(e) {
    return e.target.checked;
  }

  @Emit()
  input(value: any) {
    return value;
  }
}
